import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getDomainMeta } from "src/themes";

export const useLanguage = () => {
  let communityLang = getDomainMeta().defaultLang
  // alert(communityLang,"communityLang")
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem("language") || communityLang;
  });

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
    setCurrentLanguage(language);
    localStorage.setItem("language", language);
  };

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
      setCurrentLanguage(savedLanguage);
    }
  }, [i18n]);

  return {
    currentLanguage,
    changeLanguage,
  };
};
